import { BillingAriaModel } from "./billing-aria.model";

export const IBillingAriaList = Object.freeze({
  total: "total",
  data: "data",
});

export class BillingAriaListModel {
  constructor(data = {}) {
    this[IBillingAriaList.total] = data[IBillingAriaList.total];
    this[IBillingAriaList.data] = data[IBillingAriaList.data];
  }

  getTotal() {
    return this[IBillingAriaList.total];
  }

  getBillingAriaList() {
    return (this[IBillingAriaList.data] || []).map((row) => new BillingAriaModel(row));
  }
}
